<div class="header-nav" id="ng_header">
  <div class="nav-top" *ngIf="authService.currentUser()">
    <div class="container">
      <span
        >{{ 'HEADER.NAV.WELCOME' | translate }}
        {{ authService.currentUser()?.InfSupplierName }}</span
      >
    </div>
  </div>
  <nav class="nav">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-2">
          <app-logo></app-logo>
        </div>

        <div
          [class.col-7]="currentDir === 'rtl'"
          [class.col-8]="currentDir === 'ltr'">
          <div class="d-none d-xl-block">
            <div class="nav-link-wrapper lg-nav align-items-center d-flex">
              <ng-container [ngTemplateOutlet]="navLinks"></ng-container>
            </div>
          </div>
        </div>

        <div
          [class.col-3]="currentDir === 'rtl'"
          [class.col-2]="currentDir === 'ltr'">
          <div class="d-none d-xl-block">
            <div class="align-items-center d-flex justify-content-between">
              <div class="action-wrapper align-items-center d-flex">
                <app-lang-list></app-lang-list>

                <div
                  class="btn-action"
                  (click)="showSearch = true"
                  (keydown)="showSearch = true"
                  tabindex="1">
                  <img src="assets/icons/search.svg" alt="search" />
                </div>
              </div>

              <div class="prev-version">
                <a
                  target="_blank"
                  class="border-0 p-0"
                  href="https://digital.awqaf.gov.sa/">
                  <span
                    ><img src="assets/svg/Entry-Point.svg" alt="search"
                  /></span>
                </a>
              </div>
            </div>
          </div>

          <div class="d-block d-xl-none" style="text-align: end">
            <button class="sm-nav-btn" (click)="showNav = true">
              <img src="assets/icons/menu.svg" alt="menu" />
            </button>
          </div>
        </div>
      </div>
    </div>

    <app-global-search
      [showSearch]="showSearch"
      (onHideSearch)="showSearch = false"></app-global-search>
  </nav>
</div>

<div class="sm-nav" [class.hide]="!showNav">
  <nav [dir]="currentDir">
    <div class="action-wrapper align-items-center d-flex">
      <app-lang-list></app-lang-list>

      <div
        class="btn-action"
        (click)="showNav = false; showSearch = true"
        tabindex="2"
        (keydown)="showNav = false; showSearch = true">
        <img src="assets/icons/search.svg" alt="search" />
      </div>
    </div>

    <div class="d-flex flex-column nav-link-wrapper sm-nav-links-wrapper">
      <ng-container [ngTemplateOutlet]="navLinks"></ng-container>
    </div>

    <div class="prev-version">
      <a target="_blank" href="https://www.awqaf.gov.sa/ar" tabindex="5">
        <span>{{ 'HEADER.NAV.OLD_VERSION' | translate }}</span>
      </a>
    </div>
  </nav>

  <div (click)="showNav = false" tabindex="6" class="wrapper"></div>
</div>

<ng-template #navLinks>
  <a
    [href]="'https://www.awqaf.gov.sa/' + currentLang + '/about-us'"
    target="_blank"
    rel="noopener noreferrer"
    routerLinkActive="link-active">
    {{ 'HEADER.NAV.ABOUT_US' | translate }}
  </a>
  <a
    [href]="'https://www.awqaf.gov.sa/' + currentLang + '/regulations'"
    target="_blank"
    rel="noopener noreferrer"
    routerLinkActive="link-active">
    {{ 'HEADER.NAV.RULES_AND_REGULATIONS' | translate }}
  </a>
  <a
    [href]="'https://www.awqaf.gov.sa/' + currentLang + '/services'"
    target="_blank"
    rel="noopener noreferrer"
    routerLinkActive="link-active">
    {{ 'HEADER.NAV.SERVICES' | translate }}
  </a>
  <a
    [href]="'https://www.awqaf.gov.sa/' + currentLang + '/endowments'"
    target="_blank"
    rel="noopener noreferrer"
    routerLinkActive="link-active">
    {{ 'HEADER.NAV.ENDOWMENTS' | translate }}
  </a>
  <a
    [href]="
      'https://www.awqaf.gov.sa/' +
      currentLang +
      '/media-center?tab=authority-news&page=0'
    "
    target="_blank"
    rel="noopener noreferrer"
    routerLinkActive="link-active">
    {{ 'HEADER.NAV.MEDIA_CENTER' | translate }}
  </a>
  <a
    [href]="
      'https://www.awqaf.gov.sa/' +
      currentLang +
      '/knowledge-center?tab=visual-library'
    "
    target="_blank"
    rel="noopener noreferrer"
    routerLinkActive="link-active">
    {{ 'HEADER.NAV.KNOWLEDGE_CENTER' | translate }}
  </a>
  <a
    [href]="'https://www.awqaf.gov.sa/' + currentLang + '/help-center'"
    target="_blank"
    rel="noopener noreferrer"
    routerLinkActive="link-active">
    {{ 'HEADER.NAV.HELP_CENTER' | translate }}
  </a>
  <a
    [href]="shareYourOpinionUrl"
    target="_blank"
    rel="noopener noreferrer"
    routerLinkActive="link-active">
    {{ 'HEADER.NAV.SHARE_OPINION_HEADER' | translate }}
  </a>
</ng-template>

<!-- <header
  class="navbar bg-light flex-md-nowrap py-4"
  data-bs-theme="dark">
  <div class="d-flex flex-auto">
    <button
      class="bg-transparent border-0 p-0 mx-4"
      (click)="toggleCollapse()"
      data-testid="header-toggle-btn">
      <app-icon name="menu" size="40" color="#201B50"></app-icon>
    </button>
    <a class="navbar-brand me-0" href="#">
      <img
        src="assets/svg/logo.svg"
        width="240"
        alt="king fahd security college" />
    </a>
    <div
      class="border-end border-3 border-primary border-opacity-25 me-4 pe-4 my-2 py-3">
      <h5 class="m-0">الاشراف الاكاديمي</h5>
    </div>
  </div>

  <ul class="navbar-nav flex-row">
    <li class="nav-item text-nowrap">
      <a class="nav-link px-3" href="">
        <app-icon name="notifications" color="#F3BD48" size="40" />
      </a>
    </li>
    <li class="nav-item text-nowrap">
      <a class="nav-link px-3" href="">
        <app-icon name="settings" color="#201B50" size="40" />
      </a>
    </li>
    <li class="nav-item text-nowrap">
      <app-dropdown>
        <div button class="nav-link px-3 text-primary fs-6">
          <app-icon name="account_circle" color="#201B50" size="40" />
          <span class="px-2">اسم المستخدم </span>
        </div>

        <ng-container menu>
          <li>
            <button class="dropdown-item" (click)="logout()">Action</button>
          </li>
          <li><a class="dropdown-item" href="#">Another action</a></li>
          <li><a class="dropdown-item" href="#">Something else here</a></li>
        </ng-container>
      </app-dropdown>
    </li>
  </ul>
</header> -->
